import { render } from "./MailDetails.vue?vue&type=template&id=207db73d&scoped=true"
import script from "./MailDetails.vue?vue&type=script&lang=js"
export * from "./MailDetails.vue?vue&type=script&lang=js"

import "./MailDetails.vue?vue&type=style&index=0&id=207db73d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207db73d"]])

export default __exports__